import type {
  PublicAnalytics,
  PublicSummary,
} from "../../contracts/src/index.ts";
import {
  selectItdCashFlowNeutralReturnPct,
  selectItdMaximumDrawdownPct,
} from "../../contracts/src/index.ts";

type AccountOverviewSummary = Pick<
  PublicSummary,
  | "balance"
  | "equity"
  | "itdCashFlow"
  | "currentDrawdownPct"
>;

type AccountOverviewAnalytics = Pick<
  PublicAnalytics,
  "cumulativeReturnPct" | "currentMonthReturnPct"
> & {
  drawdown: Pick<PublicAnalytics["drawdown"], "maximumDrawdownPct">;
};

export type CanonicalAccountMetrics = Pick<
  AccountOverviewSummary,
  "balance" | "equity" | "currentDrawdownPct"
> &
  Pick<AccountOverviewAnalytics, "cumulativeReturnPct" | "currentMonthReturnPct"> & {
    maximumDrawdownPct: number | null;
  };

/**
 * Summary owns live account state and Balance/net-cash-flow ITD return;
 * analytics retains normalized-index/monthly analytics and full-history drawdown.
 */
export function getCanonicalAccountMetrics(
  summary: AccountOverviewSummary | PublicSummary | null,
  analytics: AccountOverviewAnalytics | PublicAnalytics | null,
): CanonicalAccountMetrics | null {
  if (!summary) return null;
  return {
    balance: summary.balance,
    equity: summary.equity,
    cumulativeReturnPct: selectItdCashFlowNeutralReturnPct(summary.itdCashFlow),
    currentMonthReturnPct: analytics?.currentMonthReturnPct ?? null,
    currentDrawdownPct: summary.currentDrawdownPct,
    maximumDrawdownPct: selectItdMaximumDrawdownPct(analytics?.drawdown),
  };
}
